import { put, takeLeading } from 'redux-saga/effects';

import updatePlaceOtaCredentialsApi from 'api/updatePlaceOtaCredentialsApi';
import { apiErrorHandler, showSuccess } from 'utils';

import {
  UPDATE_PLACE_OTA_CREDENTIALS,
  UPDATE_PLACE_OTA_CREDENTIALS_FAILED,
  UPDATE_PLACE_OTA_CREDENTIALS_SUCCESS,
} from './actionTypes';

function* updatePlaceOtaCredentials({ payload }) {
  try {
    yield updatePlaceOtaCredentialsApi.updatePlaceOtaCredentials(payload);

    yield put({
      type: UPDATE_PLACE_OTA_CREDENTIALS_SUCCESS,
    });

    showSuccess('Cập nhật OTA credentials thành công');

    if (payload.callback) {
      payload.callback();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: UPDATE_PLACE_OTA_CREDENTIALS_FAILED,
    });
  }
}

export default function* updatePlaceOtaCredentialsSaga() {
  yield takeLeading(UPDATE_PLACE_OTA_CREDENTIALS, updatePlaceOtaCredentials);
}
